export default __webpack_public_path__ + "static/media/carsharing.00a3bb6a.svg";